import React from 'react';
import PropTypes from 'prop-types';

const Checkbox = ({ label = '', ...props }) => (
  <label>
    <input type='checkbox' {...props} />
    <p className='input-label type-caption'>{label}</p>
  </label>
);

Checkbox.propTypes = {
  label: PropTypes.string,
};

export default Checkbox;
